import mutations from './mutations';

const state = {
    code: null
};

export default {
    namespaced: true,
    state,
    mutations,
};